import { render, staticRenderFns } from "./AssetTypeIcon.vue?vue&type=template&id=2d6b12d0&"
import script from "./AssetTypeIcon.vue?vue&type=script&lang=ts&"
export * from "./AssetTypeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports